import SectionLabel from "@/components/base/SectionLabel";
import { aiDigitalData } from "@/mocks/aiDigitalData";

export default function ImplementationSupportSection() {
  const scrollToContact = () => {
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="implementation-support" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-14 md:mb-18 reveal">
          <SectionLabel label={aiDigitalData.implementationSupport.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {aiDigitalData.implementationSupport.title}
          </h2>
        </div>

        {/* Connecting diagram concept: 4 cards with relationship lines */}
        <div className="hidden lg:block relative max-w-5xl mx-auto mb-16">
          <div className="grid grid-cols-4 gap-5">
            {aiDigitalData.implementationSupport.categories.map((cat, idx) => (
              <div
                key={cat.num}
                className="reveal flex flex-col rounded-lg bg-background-50 border border-background-200/70 p-5"
                style={{ transitionDelay: `${idx * 120}ms` }}
              >
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-xs font-bold text-primary-500 font-label">
                    {cat.num}
                  </span>
                  <h3 className="text-sm font-bold text-foreground-900 font-heading">
                    {cat.title}
                  </h3>
                </div>
                {cat.tools && (
                  <p className="text-[11px] text-foreground-500 mb-3 leading-relaxed">
                    {cat.tools}
                  </p>
                )}
                <ul className="space-y-1.5 flex-1">
                  {cat.supports.map((s) => (
                    <li key={s} className="flex items-start gap-1.5 text-[11px] text-foreground-600">
                      <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0 text-[9px]" />
                      {s}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Connecting labels between cards */}
          <div className="flex justify-between absolute top-1/2 left-0 right-0 pointer-events-none -translate-y-1/2 px-[10%]">
            <span className="text-[10px] text-primary-400 font-label bg-background-50 px-2 py-0.5 rounded-full border border-primary-200/40">
              ツール
            </span>
            <span className="text-[10px] text-accent-500 font-label bg-background-50 px-2 py-0.5 rounded-full border border-accent-200/40">
              情報
            </span>
            <span className="text-[10px] text-secondary-600 font-label bg-background-50 px-2 py-0.5 rounded-full border border-secondary-200/40">
              ルール
            </span>
            <span className="text-[10px] text-primary-400 font-label bg-background-50 px-2 py-0.5 rounded-full border border-primary-200/40">
              人
            </span>
          </div>
        </div>

        {/* Mobile/Tablet: 2-column grid */}
        <div className="lg:hidden grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 max-w-3xl mx-auto mb-12">
          {aiDigitalData.implementationSupport.categories.map((cat, idx) => (
            <div
              key={cat.num}
              className="reveal rounded-lg bg-background-50 border border-background-200/70 p-5"
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              <div className="flex items-center gap-2 mb-3">
                <span className="text-xs font-bold text-primary-500 font-label">
                  {cat.num}
                </span>
                <h3 className="text-sm font-bold text-foreground-900 font-heading">
                  {cat.title}
                </h3>
              </div>
              {cat.tools && (
                <p className="text-xs text-foreground-500 mb-3 leading-relaxed">
                  {cat.tools}
                </p>
              )}
              <ul className="space-y-1.5">
                {cat.supports.map((s) => (
                  <li key={s} className="flex items-start gap-1.5 text-xs text-foreground-600">
                    <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0" />
                    {s}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Mid CTA */}
        <div className="mt-8 md:mt-10 reveal">
          <div className="max-w-2xl mx-auto text-center bg-background-50 border border-primary-200/60 rounded-lg p-7 md:p-9">
            <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-4 font-heading">
              まずは、何を改善したいかをお聞かせください。
            </h3>
            <p className="text-sm text-foreground-600 mb-5 leading-relaxed">
              ツールの導入ありきではなく、現在の課題を整理するところから始めます。
            </p>
            <button
              onClick={scrollToContact}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              AI・デジタル導入について相談する
              <i className="ri-arrow-right-line" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}